import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addJobLocation } from 'slices/jobLocationSlice';
import { updateJobLocation } from 'slices/jobLocationSlice';
import { fetchJobLocations } from 'slices/jobLocationSlice';
import toast from 'react-hot-toast';
import { jobLocationSelector } from 'slices/jobLocationSlice';
import { setError } from 'slices/jobLocationSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { selectCustomStyles, multiSelectCustomStyles } from 'components/common/Select';
import { fetchCourtrooms } from 'slices/courtroomSlice';
import { fetchJurisdictions } from 'slices/jurisdictionSlice';
import { interpreterName } from 'helpers/interpreterName';
import { fetchInterpreters } from 'slices/interpreterSlice';
import { AsyncPaginate } from 'react-select-async-paginate';
import { fetchPoetas } from 'slices/poetaSlice';
import { fetchCourtTypes} from "slices/courtTypeSlice";

const AddJobLocationForm = ({ item, handleClose, callback, statusPerm }) => {
  const { handleSubmit, formState: { errors }, control, setValue, } = useForm();
  const dispatch = useDispatch();
  const { error, loader } = useSelector(jobLocationSelector);
  const [byZoom, setByZoom] = useState(false);
  const [courtroomState, setCourtroomState] = useState(null);
  const [jurisdictionState, setJurisdictionState] = useState(null);
  const [poetaState, setPoetaState] = useState(null);
  const [courtTypeState, setCourtTypeState] = useState(null);
  const [interpreterState, setInterpreterState] = useState(null);

  const locationName = item ? item?.name?.replace('Zoom - ', '') : '';

  console.log(item, "item")

  const filteredPoetaLoadOptions = async (
  inputValue,
  loadedOptions,
  { page }
) => {
  const result = await dispatch(
    fetchPoetas(
      page,
      {
        pageLength: 20,
        sortBy: "id",
        sortDirection: "asc",
        search: inputValue,
      },
      true,   // disableLoader
      true    // Async
    )
  );

  return {
    options: result?.map((val) => ({
      value: val.id,
      label: val.org,
    })),
    hasMore: page !== result?.last_page,
    additional: {
      page: page + 1,
    },
  };
};
  const filteredCourtTypeLoadOptions = async (
  inputValue,
  loadedOptions,
  { page }
) => {
  const result = await dispatch(
    fetchCourtTypes(
      page,
      {
        pageLength: 20,
        sortBy: "id",
        sortDirection: "asc",
        search: inputValue,
      },
      true,   // disableLoader
      true    // Async
    )
  );

  return {
    options: result?.map((val) => ({
      value: val.id,
      label: val.court_type_name,
    })),
    hasMore: page !== result?.last_page,
    additional: {
      page: page + 1,
    },
  };
};


  useEffect(() => {
    setValue('name', locationName || '');
    setValue('by_zoom', item?.by_zoom || '');
    setValue('address', item?.address || '');
    setValue('courtroom_ids', item?.job_courtrooms?.map((val) => val?.courtroom_id) || '');
    setValue('jurisdiction_ids', item?.job_jurisdictions?.map((val) => val?.jurisdiction_id) || '');
    // NOTE: excluded interpreters are hydrated by the dedicated effect below, from the
    // `job_interpreter` relation. This used to read a non-existent `item.interpreter`
    // relation and blank the field, which then deleted the saved exclusions on save.
    setValue('poeta_id', item?.poeta_id || null);
    setValue('court_type_id', item?.court_type?.id || null);
    setByZoom(item?.by_zoom);
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    if (item?.poeta) {
    setPoetaState({
      value: item?.poeta?.id,
      label: item?.poeta?.org,
    });
    } else {
      setPoetaState(null);
    }
    if (item?.court_type) {
      setCourtTypeState({
        value: item?.court_type?.id,
        label: item?.court_type?.court_type_name,
      });
    } else {
      setCourtTypeState(null);
    }

    return () => {
      dispatch(setError({}))
      setValue("name", "")
      setValue('address', '');
      setValue('by_zoom', '');
      setByZoom(false);
      setValue("status", 1)
      setValue('courtroom_ids','');
      setValue('jurisdiction_ids','');
      setCourtroomState(null)
      setJurisdictionState(null)
      // interpreter_ids / interpreterState are owned by the effect below — clearing them
      // here raced that effect and submitted an empty list, wiping saved exclusions.
    }
  }, [item, dispatch, setValue])


  // #region Language dropdown

  useEffect(() => {
    if(item?.job_courtrooms){
      setCourtroomState(
        item?.job_courtrooms?.map((val) => ({
          label: val?.courtroom?.name || "",
          value: val?.courtroom?.id || "",
        }))
      )
    }
    else{
      setCourtroomState(null)
    }
  }, [item?.job_courtrooms]);

  useEffect(() => {
    if(item?.job_jurisdictions){
      setJurisdictionState(
        item?.job_jurisdictions?.map((val) => ({
          label: val?.jurisdiction?.name || "",
          value: val?.jurisdiction?.id || "",
        }))
      )
    }
    else{
      setJurisdictionState(null)
    }
  }, [item?.job_jurisdictions]);
  // useEffect(() => {
  //   if(item?.job_interpreter){
  //     setInterpreterState(
  //       item?.job_interpreter?.map((val) => ({
  //         label: val?.interpreter?.first_name + " " + val?.interpreter?.last_name || "",
  //         value: val?.id || "",
  //       }))
  //     )
  //   }
  //   else{
  //     setInterpreterState(null)
  //   }
  // }, [item?.job_interpreter]);
  // Single source of truth for the excluded-interpreter chips + form value. Keyed on the
  // record id so it re-hydrates when a different location is opened, but a re-render of
  // the same record can't blank a list the user is editing.
  useEffect(() => {
    const excluded = (item?.job_interpreter || [])
      .filter((val) => val?.interpreter_id)
      .map((val) => ({
        label: interpreterName(val?.interpreter) || `#${val.interpreter_id}`,
        value: val.interpreter_id,
      }));

    setInterpreterState(excluded.length ? excluded : null);
    setValue("interpreter_ids", excluded.map((opt) => opt.value));
  }, [item?.id, item?.job_interpreter, setValue]);


  const filteredCourtroomLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchCourtrooms(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((val) => ({
        value: val.id,
        label: val.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  const filteredJurisdictionLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchJurisdictions(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((val) => ({
        value: val.id,
        label: val.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  const filteredInterpreterLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchInterpreters(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    console.log(result);
    return {
      options: result?.data?.map((val) => ({
        value: val.id,
        label: interpreterName(val),
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchJobLocations())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    const newData = {
      ...data,
      by_zoom: byZoom,
    };

    dispatch(setError({}))
    if (item?.id) {
      dispatch(updateJobLocation(newData, item?.id, submitCallback));
    } else {
      dispatch(addJobLocation(newData, submitCallback));
    }
  }
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>

        <div className="row-primary">
          <h2>Location Name *</h2>

          <Controller
            name="name"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Location Name' required {...field} />}
          />
        </div>

        <div className="row-primary align-items-center">
          <h2 className="m-0">By zoom</h2>
          <label className="custom-checkbox checkbox">
            <input
              type="checkbox"
              name="by_zoom"
              checked={byZoom === 1 ? true : false}
              onChange={(e) => setByZoom(e.target.checked ? 1 : 0)}
            />
            <span className="checkmark"></span>
          </label>
        </div>

        <div className="row-primary">
          <h2>Select Courtrooms *</h2>
          <Controller
            name="courtroom_ids"
            required
            rules={{
              required: "Courtroom must be specified",
            }}
            control={control}
            render={({ field }) => (
              <div className='w-100'>
                <div className='w-100'>
                  <AsyncPaginate
                    key={item?.id || "new"}
                    menuPlacement="auto"
                    isMulti
                    styles={{
                      ...multiSelectCustomStyles,
                    }}
                    closeMenuOnSelect={false}
                    value={courtroomState}
                    loadOptions={filteredCourtroomLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setCourtroomState(selected);
                      field.onChange(selected.map((opt) => opt.value));
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.courtroom_ids?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.courtroom_ids?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        <div className="row-primary">
          <h2>Select Jurisdictions *</h2>
          <Controller
            name="jurisdiction_ids"
            required
            rules={{
              required: "Jurisdiction must be specified",
            }}
            control={control}
            render={({ field }) => (
              <div className='w-100'>
                <div className='w-100'>
                  <AsyncPaginate
                    key={item?.id || "new_jurisdiction"}
                    menuPlacement="auto"
                    isMulti
                    styles={{
                      ...multiSelectCustomStyles,
                    }}
                    closeMenuOnSelect={false}
                    value={jurisdictionState}
                    loadOptions={filteredJurisdictionLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setJurisdictionState(selected);
                      field.onChange((selected || []).map((opt) => opt.value));
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.jurisdiction_ids?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.jurisdiction_ids?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        <div className="row-primary">
        <h2>Select POETA *</h2>
        <Controller
          name="poeta_id"
          required
          rules={{
            required: "POETA must be specified",
          }}
          control={control}
          render={({ field }) => (
            <div className='w-100'>
              <AsyncPaginate
                key={item?.id || "new_poeta"}
                menuPlacement="auto"
                styles={{
                  ...selectCustomStyles,
                }}
                value={poetaState}
                loadOptions={filteredPoetaLoadOptions}
                isClearable
                escapeClearsValue
                onChange={(selected) => {
                  setPoetaState(selected);
                  field.onChange(selected ? selected.value : null);
                }}
                additional={{
                  page: 1,
                }}
              />
              {errors?.poeta_id?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.poeta_id?.message} />
                </div>
              )}
            </div>
          )}
        />
      </div>
        <div className="row-primary">
        <h2>Select Court Type *</h2>
        <Controller
          name="court_type_id"
          required
          rules={{
            required: "Court Type must be specified",
          }}
          control={control}
          render={({ field }) => (
            <div className='w-100'>
              <AsyncPaginate
                key={item?.id || "new_court_type"}
                menuPlacement="auto"
                styles={{
                  ...selectCustomStyles,
                }}
                value={courtTypeState}
                loadOptions={filteredCourtTypeLoadOptions}
                isClearable
                escapeClearsValue
                onChange={(selected) => {
                  setCourtTypeState(selected);
                  field.onChange(selected ? selected.value : null);
                }}
                additional={{
                  page: 1,
                }}
              />
              {errors?.court_type_id?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.court_type_id?.message} />
                </div>
              )}
            </div>
          )}
        />
      </div>

        <div className="row-primary">
          <h2>Location Address</h2>
          <Controller
            name="address"
            control={control}
            render={({ field }) => (
              <textarea
                className="type_inp input-in"
                {...field}
                placeholder="Type here..."
              ></textarea>
            )}
          />
        </div>

        <div className="row-primary">
          <h2>Excluded Interpreters</h2>
          <Controller
            name="interpreter_ids"
            // required
            control={control}
            render={({ field }) => (
              <div className='w-100'>
                <div className='w-100'>
                  <AsyncPaginate
                      key={item?.id || "new"}
                      menuPlacement="auto"
                      isMulti
                      styles={{ ...multiSelectCustomStyles }}
                      closeMenuOnSelect={false}
                      value={interpreterState}
                      loadOptions={filteredInterpreterLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(selected) => {
                        setInterpreterState(selected);
                        field.onChange(selected.map((opt) => opt.value));
                      }}
                      additional={{ page: 1 }}
                    />
                </div>
                {errors?.interpreter_ids?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.interpreter_ids?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        {statusPerm &&
          <div className="row-primary flex-row align-items-center" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>Status</h2>
            <Controller
              name="status"
              control={control}
              required
              rules={{
                required: true
              }}
              render={({ field }) => (
                <CustomSwitch
                  labelText="active"
                  checked={field.value == 1 ? true : false}
                  handleChange={(checked) => field.onChange(checked ? 1 : 0)}

                />
              )}
            />
          </div>
        }
        {error?.errors?.name?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <SubmitButton
            loader={loader}
            btnText={item?.id ? "Update" : "Create"}
          />

        </div>
      </form>

    </div>
  )
}

const AddJobLocation = ({ item, onClose, callback, statusPerm }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Job Location</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddJobLocationForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddJobLocation
